// extracted by mini-css-extract-plugin
export default {"inputWithWordCount":"InputWithWordCount_inputWithWordCount__qIS4M","inputWithWordCount__count":"InputWithWordCount_inputWithWordCount__count__NMGoE"};